// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Timestamp$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as TableComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";

function getTableColumnsSchema(param) {
  return {
          hd: {
            column: {
              TAG: /* Text */0,
              _0: "Timestamp"
            },
            accessor: (function (log) {
                return {
                        TAG: /* Text */0,
                        _0: Timestamp$Catalyst.toString(Timestamp$Catalyst.make(log.ts_millis), "DD MMM hh:mm A")
                      };
              })
          },
          tl: {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Detail"
              },
              accessor: (function (log) {
                  return {
                          TAG: /* Text */0,
                          _0: log.description
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "Admin"
                },
                accessor: (function (log) {
                    return {
                            TAG: /* Text */0,
                            _0: log.admin
                          };
                  })
              },
              tl: /* [] */0
            }
          }
        };
}

function getView(order_logs) {
  return React.createElement(TableComponent$Catalyst.make, {
              columns: getTableColumnsSchema(undefined),
              rowData: order_logs,
              className: "order-table"
            });
}

export {
  getTableColumnsSchema ,
  getView ,
  
}
/* react Not a pure module */
